import React, { useState } from "react";
import "./CreateDispositionModal.scss";
import OwButton from "../../shared/OwButton/OwButton";
import OwTitle from "../../shared/OwTitle/OwTitle";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwDateInput from "../../shared/OwDateInput/OwDateInput";
import moment, { Moment } from "moment-timezone";

type Props = {
    closeModalFn: () => void;
    submitFn: (date: string) => void;
    isSubmitting: boolean;
    error?: string | React.ReactNode | null;
    result?: { dispositionIds: string[] } | null;
};

export const CreateDispositionModal: React.FC<Props> = (props) => {
    const [date, setDate] = useState<Moment>(moment());

    const handleDateChange = (newDate: Moment) => {
        setDate(newDate);
    };

    const handleSubmit = () => {
        props.submitFn(date.format("YYYY-MM-DD"));
    };

    return (
        <div className={"CreateDispositionModal p-2"}>
            <div className={"modal-header d-flex justify-content-between align-items-center"}>
                <OwTitle leftIconName={"fas fa-file-export"} title={"create_disposition"} tag={"h3"} defaultMargins={false} />
                <OwButton className={"btn-danger"} centerIconClass={"fas fa-times"} fn={props.closeModalFn} />
            </div>

            <div className={"modal-body"}>
                {!props.result && (
                    <div>
                        <OwLabel title={"disposition_date"} />
                        <OwDateInput selectedDate={date} fn={handleDateChange} disabled={props.isSubmitting} />
                    </div>
                )}

                {props.result && (
                    <div className={"text-success"}>
                        <i className={"fas fa-check-circle me-2"} />
                        {props.result.dispositionIds.length} disposition(s) created successfully.
                    </div>
                )}

                {props.error && <div className={"text-danger mt-2"}>{typeof props.error === "string" ? props.error : props.error}</div>}
            </div>

            <div className={"modal-footer d-flex justify-content-between align-items-center"}>
                <OwButton className={"btn-danger"} title={props.result ? "close" : "cancel"} fn={props.closeModalFn} />
                {!props.result && <OwButton title={"submit"} fn={handleSubmit} disableOnActive={true} active={props.isSubmitting} />}
            </div>
        </div>
    );
};
